module.exports = __webpack_public_path__ + "img/ctrl-stub-+.c9786218.svg";